export default "__VITE_ASSET__SP83$q7D__"